<div class="w-full">
    <div 
        (click)="openPanel($event)"
        class="flex items-center justify-between border rounded-lg hover:cursor-pointer"
        [ngClass]="{ 'border-palette-blue-300 shadow-[0_0_0_4px_#EAF3FF,0_1px_2px_0_rgba(16,24,40,0.05)]': overlayVisible }"
    >
        <div class="flex items-center">
            <span class="!mx-2 text-palette-gray-900 whitespace-nowrap font-inter !font-semibold text-sm">
                {{ 'CALENDAR.' + selectedPreset | translate }}:
            </span>
            <input
                readonly
                class="fl-input-1 hover:cursor-pointer focus-visible:outline-none"
                [value]="displayValue"
            />
        </div>
        <i
            class="sctr-icon-calendar text-palette-gray-500 text-xl leading-4 hover:cursor-pointer !mr-2"
        ></i>
    </div>

    <!-- Overlay -->
    <p-overlayPanel #overlay (onHide)="onCancel()">
        <div class="flex gap-4 admin-custom">
            <!-- Preset list -->
            <div class="flex flex-col gap-1">
                <label
                    *ngFor="let k of presetKeys"
                    (click)="setPreset(k)"
                    class="cursor-pointer py-1 text-sm font-medium"
                    [ngClass]="{
                        'text-palette-blue-600': selectedPreset === k,
                        'hover:text-palette-blue-500': selectedPreset !== k
                    }"
                >
                    {{ ('CALENDAR.' + k) | translate | sentenceCase }}
                </label>
            </div>

            <!-- Calendar & custom inputs -->
            <div>
                <p-calendar
                    class="fl-calendar-1"
                    [(ngModel)]="calendarModel"
                    [inline]="true"
                    view="date"
                    selectionMode="range"
                    [firstDayOfWeek]="locale === 'vi' ? 1 : 0"
                    (ngModelChange)="onCalendarChange($event)"
                    [numberOfMonths]="2"
                >
                    <ng-template pTemplate="date" let-date>
                        <div
                            class="flex items-center justify-center
                                !h-[38px] w-full
                                hover:!bg-palette-blue-400
                                hover:!text-white"
                            [ngClass]="{
                                'start-date': isStartDate(date),
                                'end-date': isEndDate(date),
                                'in-range': isInRange(date)
                            }"
                        >
                            {{date.day}}
                        </div>
                    </ng-template>
                </p-calendar>

            <!-- Manual inputs -->
            <form [formGroup]="form" class="mt-3 flex justify-between search-custom">
                <div class="flex gap-1">
                    <div class="max-w-[170px]">
                        <p-inputMask
                            formControlName="start"
                            mask="99/99/9999"
                            class="custom-input-mask max-w-[150px]"
                            (onBlur)="syncRangeFromForm()"
                            [placeholder]="'COMMON.FORMAT_DATE' | translate">
                        </p-inputMask>
                        <div *ngIf="fc.start.invalid && fc.start.touched" class="invalid-feedback !mt-1">
                            <i class="sctr-icon-alert-circle mr-1"></i>
                            <ng-container *ngIf="fc.start.errors?.['required']">
                                {{ 'CALENDAR_FILTER.DATE_IS_REQUIRED' | translate }}
                            </ng-container>
                            <ng-container *ngIf="fc.start.errors?.['format']">
                                {{ 'CALENDAR_FILTER.WRONG_FORMAT' | translate }}
                            </ng-container>
                        </div>
                    </div>
                    <span class="pt-2">-</span>
                    <div class="max-w-[170px]">
                        <p-inputMask
                            formControlName="end"
                            mask="99/99/9999"
                            class="custom-input-mask max-w-[150px]"
                            (onBlur)="syncRangeFromForm()"
                            [placeholder]="'COMMON.FORMAT_DATE' | translate"
                            [disabled]="fc.start.invalid">
                        </p-inputMask>
                        <div *ngIf="fc.end.invalid && fc.end.touched" class="invalid-feedback !mt-1">
                            <i class="sctr-icon-alert-circle mr-1"></i>
                            <ng-container *ngIf="fc.end.errors?.['required']">
                                {{ 'CALENDAR_FILTER.DATE_IS_REQUIRED' | translate }}
                            </ng-container>
                            <ng-container *ngIf="fc.end.errors?.['format']">
                                {{ 'CALENDAR_FILTER.WRONG_FORMAT' | translate }}
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="flex gap-2">
                    <button
                        (click)="onCancel()"
                        class="!h-11 !w-[88px] rounded-lg border bg-white !px-5
                                !py-3 font-inter !text-sm font-semibold text-palette-gray-900">
                        {{ "COMMON.CANCEL" | translate }}
                    </button>
                    <button
                        (click)="onApply()"
                        class="!h-11 !min-w-[88px] rounded-lg border 
                            bg-palette-blue-600 !px-5 !py-3 font-inter !text-sm font-semibold text-white">
                        {{ "COMMON.APPLY" | translate }}
                    </button>
                </div>
            </form>
            </div>
        </div>
    </p-overlayPanel>
</div>